<template>
  <div id="curmb">
    <div class="breadcrumb container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          v-for="(item,index) in crumb"
          :key="index"
          @click.native="toHome(item)"
          >
          <span>{{ item.title }}</span>
        </el-breadcrumb-item>

      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    crumb:{
      type:Array,
    }
  },
  data(){
    return{

    }
  },
  methods:{
    toHome(item){
      if(item.title == '首页'){
        window.location.href=item.link
      }else{
        // console.log(this.$route.query)
        this.$router.push({
          path:item.link,
          query:this.$route.query
        })
      }
    }
  }
}
</script>


<style lang="less" scoped>
#curmb{
  width: 100%;
  margin-bottom: 10px;
	.breadcrumb{
    margin: 24px auto;
		.el-breadcrumb{
      font-size: 16px;
      /deep/.el-breadcrumb__item:not(:last-child){
        color:#303133 !important;
        font-weight: 700;
        .el-breadcrumb__inner{
          span{
            cursor: pointer;
            transition: all 0.3s;
          }
          :hover{
            color:#00AF86 !important;
          }
        }
      }
		}
	}
}
</style>

